window.siteDomain =
  location.origin || /^[^/]+?[/]{2}[^/]+/.exec(location.href)[0];

window.requireQueue = [];
window.queueRequire = (cb) => window.requireQueue.push(cb);

const experimentsRequire = require.context(
  'app/common/lib/experiments/config',
  false,
  /\.json$/,
);
window.abTests = experimentsRequire.keys().reduce((acc, path) => {
  const segments = path.split('/');
  const name = segments[segments.length - 1].split('.')[0];
  acc[name] = experimentsRequire(path);

  return acc;
}, {});



// WEBPACK FOOTER //
// ./app/scripts/entry/bootstrap.js